import analyticsMixin from "@/mixins/analytics-mixin";
import { routeData } from "@/router/constants/routes";
import router from "@/router";
import store from "@/store";
import { storeActions } from "@/constants/store-actions";
import { deleteFunnelCookie } from "@/helpers/heritage-integration/cookie-helper";

export async function bailout(errorPayload, forceRestart = false) {
    if (forceRestart) {
        await store.dispatch(storeActions.RESET_STATE);
        deleteFunnelCookie();
    }

    analyticsMixin.methods.pushPageErrorToDataLayer(errorPayload);

    router.push({
        name: routeData.ERROR.name,
    });
}
